import { Tag } from 'antd';
import { useContext } from 'react';

import { FRONT_WARNING } from '@app/constants';
import { CHF_TAG_IDS } from '@app/pages/Clients/ClientsList/constants/filterKeysAndIds';
import { NotificationContext } from '@app/providers';

import {
  getDataBeforeTargetKey,
  getFilterValuesRest,
} from '@pages/Clients/ClientsList/utils';

import type { NClientsList } from '@pages/Clients/ClientsList/ClientsList.types';

import type { FC } from 'react';

export const ClientFilterTag: FC<NClientsList.ClientFilterTagProps> = ({
  children,
  componentKey,
  filters,
  serverFilters,
  filtersArea,
  filterGroupIndex,
  valueKey,
  specificFilterArrayIndex,
  isPeriodFilter = false,
  additionalCondition = true,
  setFilters,
  setServerFilters,
  handleTagDeletion,
}) => {
  const { showNotification } = useContext(NotificationContext);

  const getTargetData = (oldFilters: NClientsList.Filters) => {
    if (!valueKey) return null;

    const startMainSolution = () =>
      getDataBeforeTargetKey({
        oldFilters,
        filtersArea,
        filterGroupIndex,
      })?.[0]?.[valueKey];

    if (isPeriodFilter) return startMainSolution();

    return valueKey ? startMainSolution() : null;
  };
  const isTargetFilterEnabled = getTargetData(serverFilters) !== null;

  const deleteTag = (
    filters: NClientsList.Filters,
    serverFilters: NClientsList.Filters
  ): void => {
    if (!valueKey)
      return showNotification(
        'Название изменяемого фильтра не найдено',
        FRONT_WARNING
      );

    if (
      getTargetData(filters) !== null &&
      getTargetData(serverFilters) !== null
    ) {
      const updateFilters: NClientsList.UpdateFilters = (type, oldFilters) => {
        const filterValuesRest = getFilterValuesRest({
          type,
          filtersArea,
          filterGroupIndex,
          filters,
          serverFilters,
        });

        return {
          ...oldFilters,
          [filtersArea]: Object.values({
            ...oldFilters[filtersArea],
            [filterGroupIndex]: {
              ...oldFilters[filtersArea][filterGroupIndex],
              Values: [
                {
                  ...filterValuesRest,
                  [valueKey]:
                    specificFilterArrayIndex &&
                    Array.isArray(filterValuesRest[valueKey])
                      ? (filterValuesRest[valueKey] || []).filter(
                          (item, index) =>
                            index + 1 !== specificFilterArrayIndex
                        )
                      : null,
                },
              ],
            },
          }),
        };
      };

      setFilters(updateFilters('filters', filters));
      return setServerFilters(updateFilters('serverFilters', serverFilters));
    } else {
      showNotification(
        'Данные по изменяемому фильтру не найдены',
        FRONT_WARNING
      );
    }
  };

  return (
    <>
      {(valueKey === CHF_TAG_IDS ? true : isTargetFilterEnabled) &&
        additionalCondition && (
          <Tag
            key={componentKey}
            closable
            bordered={false}
            onClose={
              handleTagDeletion
                ? () => handleTagDeletion()
                : () => deleteTag(filters, serverFilters)
            }
          >
            {children}
          </Tag>
        )}
    </>
  );
};
